import { PackageScanModesFormGzDataProvider } from '../dataProvider/PackageScanModesFormGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class PackageScanModesFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PackageScanModesFormGzDataProvider);
  }
}
